module.exports = __webpack_public_path__ + "static/1_1-fdd1684fc5c70ecf4b65ff1e2c62eb6b.mp4";